module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, _vm._l((_vm.screens), function(screen, index) {
    return _c('div', {
      key: ("screen-index-" + index),
      staticClass: "screen",
      attrs: {
        "id": ("screen-" + screen)
      }
    }, [(screen !== 'cover') ? _c('nav-menu', {
      attrs: {
        "active": screen,
        "items": _vm.screens
      }
    }) : _vm._e(), _vm._v(" "), _c(screen, {
      tag: "component"
    })], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74ebf3eb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 119
// module chunks = 1